import { fireLinkTag } from './tagManager';

/**
 * @param {TrueFitResponce['response']['tfpUser']['isCredentialSaved']} isCredentialSaved
 * @param {FitRecommendation['size']} size
 */
function getUserStatus(isCredentialSaved, size) {
  if (isCredentialSaved) {
    return size ? 'Signed In with Recommendation' : 'Signed In without Recommendation';
  }
  return size ? 'Guest with Recommendation' : 'Guest without Recommendation';
}

/**
 * @param {{productId: ProductId}} productId
 */
export function tagFitrecRegisterOpen({ productId }) {
  fireLinkTag({
    event_name: 'true fit: which size fits me',
    link_name: 'true fit: which size fits me',
    product_id: [productId],
  });
}

/**
 * @param {{productId: ProductId}} productId
 */
export function tagFitrecRegisterComplete({ productId }) {
  fireLinkTag({
    product_size_predictor: ['truefit complete'],
    product_id: [productId],
  });
}

/**
 *
 * @param {TrueFitResponce} response
 * @param {ProductId} productId
 * @param {boolean} isRecommendedSizeAvailable
 */
export function tagRecomendSize(response, productId, isRecommendedSizeAvailable) {
  const size = response?.fitRecommendation?.size;
  const isCredentialSaved = response?.response?.tfpUser?.isCredentialSaved;

  fireLinkTag({
    event_name: 'true fit',
    product_id: productId,
    true_fit_size_recommendation_available: size ? ['true'] : ['false'],
    product_size_recommended_available: isRecommendedSizeAvailable,
    true_fit_customer_status: getUserStatus(isCredentialSaved, size),
    size_auto_select: ['true'],
  });
}

export default tagFitrecRegisterOpen;
